module.exports = {"id":"222028","name":"Julian Weigl","rating":"81","photo":"./data/images/photos/3/222028.png","club":{"name":"Bor. Dortmund","logo":"./data/images/clubs/Bor.Dortmund.png"},"positions":["MDC","MC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JulianWeigl0.json
// module id = 2245
// module chunks = 0